import React, { useContext } from "react";

import ShotList from "./shot-list";
import LocaleSelector from "../components/locale-selector";
import Tabs from "../../tabs";

import { PhotographyContext } from "../../../contexts/photography";
import { ShotContext } from "../context/index";

const ShotLocale = ({ isFinalized, isCompleted, showEcom, isVOUpload, isVODelete, isVOSourceEdit }) => {
    const { lookups } = useContext(PhotographyContext);
    const { addLocale, changeLocale, removeByLocaleCode, selectedLocale, shotsByLocale } = useContext(ShotContext);

    const addTab = (index, data) => {
        addLocale(data);
        changeLocale(data);
    };

    const onTabChange = (index, data) => {
        changeLocale(data);
    };

    const removeTab = (index, data) => {
        const localeCode = data && data.value ? data.value : null;

        if (!localeCode) {
            return;
        }

        removeByLocaleCode(localeCode);
    };

    const tabs = [];
    const locales = Object.keys(shotsByLocale).map((l) => {
        tabs.push({ ...lookups.localeByKey[l] });

        return (
            <ShotList
                key={`shot-list-${l}`}
                showEcom={showEcom}
                //extraShotUploading={props.extraShotUploading} // TODO: This
                shots={shotsByLocale[l]}
                localeCode={l}
                isCompleted={isCompleted}
                isFinalized={isFinalized}
                roUploadImage={isVOUpload}
                roDeleteImage={isVODelete}
                roSourceEdit={isVOSourceEdit}
            />
        );
    });

    return (
        <Tabs
            addTab={addTab}
            selectedTab={selectedLocale ? selectedLocale.value : ""}
            tabs={tabs}
            TabDropdown={LocaleSelector}
            reportSelectedTab={onTabChange}
            removeTab={removeTab}
            readOnly={isVOUpload || isCompleted}
        >
            {locales}
        </Tabs>
    );
};

export default ShotLocale;
